module.exports = __webpack_public_path__ + "img/border_outer.fdb76791.svg";